import React, { useEffect, useState } from 'react';
import { get, isEmpty, groupBy } from 'lodash';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPerformanceRecord } from '../../../actions/performanceRecordActions';
import PageHeading from '../../../components/PageHeading';
import { Grid, Button } from '@material-ui/core';
import { dateFormat } from '../../../api/dateFormat';
import LineGraphsSlider from './components/LineGraphSlider';
import NoData from '../../../components/NoData';
import './styles.scss';
import OverAllPerformanceTable from './components/OverAllPerformanceTable';
import { Skeleton } from '@material-ui/lab';

export default function PerformanceRecord() {
  // Redux
  const dispatch = useDispatch();
  const [isFetching, setIsFetching] = useState(false);

  const loginData = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const TableData = useSelector((state) =>
    get(state, 'performanceRecordReducer.data.attendance', [])
  );
  const ErrorMessage = useSelector((state) =>
    get(state, 'performanceRecordReducer.errorMessage', '')
  );
  const analysisGraph = useSelector((state) =>
    get(state, 'performanceRecordReducer.data.analysisGraph', [])
  );
  const TestPerformanceRecordData = useSelector((state) =>
    get(state, 'performanceRecordReducer.data.testRecord', {})
  );

  // useEffect(() => {
  //   setIsFetching(true);
  //   fetchPerformanceRecord(loginData, dispatch).then(() => {
  //     setIsFetching(false);
  //   });
  // }, []);

  useEffect(() => {
    setIsFetching(true);
    fetchPerformanceRecord(loginData, dispatch).then(() => {
      setIsFetching(false);
    });
  }, [loginData]);

  const getGraphData = (label) => {
    const groupedData = groupBy(analysisGraph, 'SubjectName');
    const dataToPopulate = !isEmpty(groupedData) ? groupedData[label] : [];
    const values = [];
    !isEmpty(dataToPopulate) &&
      dataToPopulate.map((row) => {
        values.push({
          date: dateFormat(row.TestDate),
          testPercent: row.TestPercent,
        });
      });
    return values;
  };
  const populateSubjectGraph = () => {
    const graph = [];
    const groupedData = isFetching ? [] : groupBy(analysisGraph, 'SubjectName');
    const subjects = isFetching
      ? [1, 1, 1]
      : !isEmpty(groupedData)
      ? Object.keys(groupedData)
      : [];
    !isEmpty(subjects) &&
      subjects.map((subject, index) => {
        subject !== 'TOTAL' &&
          graph.push(
            <Grid item xs={12} sm={4} md={4} key={index}>
              <div className="slider-graph-container">
                <h4 className="graph-cards-heading">
                  {isFetching ? <Skeleton /> : subject}
                </h4>
                {isFetching ? (
                  <Skeleton variant="rect" height="200px" />
                ) : (
                  <LineGraphsSlider analysisGraph={getGraphData(subject)} />
                )}
              </div>
            </Grid>
          );
      });
    return graph;
  };
  return isEmpty(TableData) &&
    isEmpty(analysisGraph) &&
    (isEmpty(TestPerformanceRecordData.main_header) ||
      isEmpty(TestPerformanceRecordData.detail)) &&
    !isFetching ? (
    <React.Fragment>
      <PageHeading titlePrimary="Performance" titleSecondary="Report" />
      <NoData
        message={
          !isEmpty(ErrorMessage)
            ? ErrorMessage
            : 'As of now, no Performance Report is available for you. Please come back later.'
        }
      />
    </React.Fragment>
  ) : (
    <div id="section-to-print">
      <Grid container>
        <Grid item xs={true}>
          <PageHeading titlePrimary="Performance" titleSecondary="Report" />
        </Grid>
        {!isFetching && (
          <Grid item xs="auto">
            <Link to={`/performance-report/print`}>
              <Button
                variant="contained"
                color="secondary"
              >
                Print
              </Button>
            </Link>
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2}>
        {/* <Grid item xs={12} sm={6} md={6}>
          <div className="section">
            <h3 className="heading">Students Attendance Record</h3>
            {!isEmpty(TableData) || isFetching ? (
              <AttendanceComponent
                tableData={TableData}
                isFetching={isFetching}
              />
            ) : (
              <div className="card content-card score-table-container">
                <NoData
                  message={
                    !isEmpty(ErrorMessage)
                      ? ErrorMessage
                      : 'For Online ADC watch, attendance feature will be started after few weeks.'
                  }
                />
              </div>
            )}
          </div>
        </Grid> */}
        <Grid item xs={12} sm={12} md={12}>
          <div className="section">
            <h3 className="heading">Overall Performance Analysis</h3>
            <div className="card content-card slider-container">
              {isFetching ? (
                <Skeleton variant="rect" height="320px" />
              ) : !isEmpty(analysisGraph) ? (
                <LineGraphsSlider analysisGraph={getGraphData('TOTAL')} />
              ) : (
                <NoData
                  message={
                    !isEmpty(ErrorMessage)
                      ? ErrorMessage
                      : 'As of now, No Performance Analysis Chart is available'
                  }
                />
              )}
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <div className="section pt-20 mb-30">
            <h3 className="heading">Overall Performance Record</h3>
            {isFetching ? (
              <Skeleton variant="rect" height="100px" />
            ) : (
              <OverAllPerformanceTable
                data={
                  !isEmpty(TestPerformanceRecordData)
                    ? TestPerformanceRecordData
                    : []
                }
              />
            )}
          </div>
        </Grid>
      </Grid>
      <div className="section">
        <h3 className="heading">Subject Performance Analysis</h3>
        <div className="card content-card slider-container">
          {!isEmpty(analysisGraph) || isFetching ? (
            <Grid container spacing={2}>
              {populateSubjectGraph()}
            </Grid>
          ) : (
            <NoData
              message={
                !isEmpty(ErrorMessage)
                  ? ErrorMessage
                  : 'As of now, No Subject Charts are available'
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}
